import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchAnnotations = ({ snapshotId }) =>
  HttpClient().get(`/annotations/v1/${snapshotId}`, {
    params: {
      include: 'messages,user,user.avatar_asset_reference',
    },
  })

const getAnnotations = (options) => (dispatch) =>
  fetchAnnotations(options)
    .then((response) => {
      const body = response.data
      if (body.data && body.data.length) dispatch(loadJsonApiEntities(body))

      return body
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getAnnotations
